import React, { useEffect, useRef, useState } from 'react';
import CKEditor from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { Button, Popover, TextField } from '@material-ui/core';
import { titanAviInstance } from '.';
import { useSnackbar } from 'notistack';
const MAX_TABLE_ROWS = 50;
export default function CkEditorText({htmlData, onChangeData, onBlurData, disabled=false,onFocusData,placeholder}){
  const isFirstLoad = useRef(true);
  const editorRef = useRef(null);
  const [insertTableAnchor, setInsertTableAnchor] = useState(null);
  const [tableRows, setTableRows] = useState(10);
  const [tableColumns, setTableColumns] = useState(3);
  const [isExistingTable, setIsExistingTable] = useState(false);
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  useEffect(()=>{
    isFirstLoad.current = false;
  },[])
  const getSelectedTable = (editor) => {
    const position = editor.model.document.selection.getFirstPosition();
    if (!position) return null;
    return position.getAncestors().find(ancestor => ancestor.is('element', 'table')) || null;
  }
  const selectCell = (editor, cell) => {
    editor.model.change(writer => {
      writer.setSelection(writer.createRangeIn(cell));
    });
  }
  const resizeTable = (editor, table, rows, columns) => {
    const tableUtils = editor.plugins.get('TableUtils');
    const currentRows = tableUtils.getRows(table);
    const currentColumns = tableUtils.getColumns(table);
    if (rows > currentRows) {
      tableUtils.insertRows(table, { at: currentRows, rows: rows - currentRows });
    } else if (rows < currentRows) {
      for (let i = currentRows; i > rows; i--) {
        const lastRow = table.getChild(i - 1);
        selectCell(editor, lastRow.getChild(0));
        editor.execute('removeTableRow');
      }
    }
    if (columns > currentColumns) {
      tableUtils.insertColumns(table, { at: currentColumns, columns: columns - currentColumns });
    } else if (columns < currentColumns) {
      for (let i = currentColumns; i > columns; i--) {
        const firstRow = table.getChild(0);
        selectCell(editor, firstRow.getChild(i - 1));
        editor.execute('removeTableColumn');
      }
    }
  }
  const onInsertTable = () => {
    const editor = editorRef.current;
    const rows = Math.max(1, parseInt(tableRows, 10) || 1);
    const columns = Math.max(1, parseInt(tableColumns, 10) || 1);
    if(rows > 100 || columns > 100 ){
      enqueueSnackbar ("Max allowed table size is 100 * 100.", { variant: 'error',anchorOrigin:{horizontal:'right', vertical:'top'}})
    } else{
    const existingTable = getSelectedTable(editor);
    if (existingTable) {
      resizeTable(editor, existingTable, rows, columns);
    } else {
      editor.execute('insertTable', { rows, columns });
    }
    editor.editing.view.focus();
    setIsExistingTable(true);
    setInsertTableAnchor(null);
    }
  }
  const onOpenInsertTable = (e) => {
    const editor = editorRef.current;
    const existingTable = editor ? getSelectedTable(editor) : null;
    if (existingTable) {
      const tableUtils = editor.plugins.get('TableUtils');
      setTableRows(tableUtils.getRows(existingTable));
      setTableColumns(tableUtils.getColumns(existingTable));
    } else {
      setTableRows(10);
      setTableColumns(3);
    }
    setIsExistingTable(Boolean(existingTable));
    setInsertTableAnchor(e.currentTarget);
  }
  return(
    <div className="ck-content">
      { !disabled && titanAviInstance &&
        <div style={{textAlign:'right', marginBottom:'4px'}}>
          <Button size='small' variant='outlined' color='primary' onClick={onOpenInsertTable}>{ isExistingTable ?'Update' :'Insert'} Table</Button>
          <Popover
            open={Boolean(insertTableAnchor)}
            anchorEl={insertTableAnchor}
            onClose={() => setInsertTableAnchor(null)}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
            transformOrigin={{ vertical: 'top', horizontal: 'right' }}
          >
            <div style={{ padding: '12px', display: 'flex', gap: '8px', alignItems: 'center' }}>
              <TextField
                size='small'
                variant='outlined'
                type='number'
                label='Rows'
                style={{ width: '80px' }}
                inputProps={{ min: 1, max: MAX_TABLE_ROWS }}
                value={tableRows}
                onChange={(e) => setTableRows(e.target.value)}
              />
              <TextField
                size='small'
                variant='outlined'
                type='number'
                label='Columns'
                style={{ width: '90px' }}
                inputProps={{ min: 1 }}
                value={tableColumns}
                onChange={(e) => setTableColumns(e.target.value)}
              />
              <Button size='small' variant='contained' color='primary' onClick={onInsertTable}>{isExistingTable ? 'Update' : 'Insert'}</Button>
            </div>
          </Popover>
        </div>
      }
      <CKEditor
        editor={ ClassicEditor }
        data={htmlData}
        disabled={disabled}
        config={{removePlugins:['MediaEmbed', 'ImageUpload', 'Indent'],placeholder: placeholder || "Please Enter..."}}
        onInit={ editor => {
            editorRef.current = editor;
            editor.model.document.selection.on('change:range', () => {
              setIsExistingTable(Boolean(getSelectedTable(editor)));
            });
        }}
        onChange={(event, editor) => {
          const data = editor.getData();
          if (isFirstLoad.current) return; // Skip first auto-change
          if (typeof onChangeData === 'function') onChangeData(data);
        }}
        onBlur={ ( event, editor ) => {
          if (typeof onBlurData === 'function') {
            const data = editor.getData();
            onBlurData(data);
          }
        }}
        onFocus={ ( event, editor ) => {
          if (typeof onFocusData === 'function') {
            const data = editor.getData();
            onFocusData(data);
          }
        }}
      />
    </div>
  )
}

